module.exports = __webpack_public_path__ + "static/media/transactionIcon.7d8be5b2.svg";